// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ZRZeB","name":"Card_name__mZX3O","price":"Card_price__UTqXT","img_holder":"Card_img_holder__hug7K","img":"Card_img__VVOsi","btn":"Card_btn__zx9n2"};